function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as React from 'react';
import { Menu, MenuButton, MenuHeader, MenuList, MenuItem, MenuFooter, Columns, Text, Select, Icon, Box } from "./..";
import { PaginationItem } from "./paginationItem";
var defaultRowLimitOptions = [15, 25, 50, 100];
export var MiniPagination = function MiniPagination(_ref) {
  var pageSize = _ref.pageSize,
      totalCount = _ref.totalCount,
      currentPage = _ref.currentPage,
      onPageChange = _ref.onPageChange,
      onPageSizeChange = _ref.onPageSizeChange,
      _ref$rowLimitOptions = _ref.rowLimitOptions,
      rowLimitOptions = _ref$rowLimitOptions === void 0 ? defaultRowLimitOptions : _ref$rowLimitOptions,
      _ref$strings = _ref.strings,
      strings = _ref$strings === void 0 ? {
    of: 'OF',
    goTo: 'Go to',
    showUpTo: 'Show up to'
  } : _ref$strings;
  var totalPageSize = Math.ceil(totalCount / pageSize);
  var pageStart = (currentPage - 1) * pageSize + 1;
  var pageEnd = currentPage === totalPageSize ? totalCount : currentPage * pageSize;
  var rowLimitItems = React.useMemo(function () {
    return rowLimitOptions.map(function (option) {
      return {
        id: option,
        label: "".concat(option, " ITEMS"),
        value: option
      };
    });
  }, [rowLimitOptions]);
  var fn = React.useCallback(function (n, l) {
    return _toConsumableArray(Array(n)).map(function (_, id) {
      return {
        page: id + 1,
        lowerLimit: Math.floor(l * id + 1),
        upperLimit: Math.min(totalCount, Math.floor(l * (id + 1)))
      };
    });
  }, [totalCount]);
  var pageList = fn(totalPageSize, pageSize);
  return /*#__PURE__*/React.createElement(Columns, {
    alignY: "center"
  }, /*#__PURE__*/React.createElement(Menu, {
    palette: "light"
  }, /*#__PURE__*/React.createElement(MenuButton, {
    palette: "neutral"
  }, pageStart, " - ", pageEnd, " ", strings.of, " ", totalCount), /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuHeader, null, /*#__PURE__*/React.createElement(Text, {
    color: "black",
    fontSize: 2,
    fontWeight: "medium"
  }, strings.goTo)), /*#__PURE__*/React.createElement(Box, {
    maxHeight: "200px",
    overflowX: "none",
    overflowY: "auto",
    sx: {
      boxSizing: 'none'
    }
  }, pageList.map(function (_ref2) {
    var page = _ref2.page,
        lowerLimit = _ref2.lowerLimit,
        upperLimit = _ref2.upperLimit;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: page,
      onClick: function onClick() {
        return onPageChange(page);
      },
      paddingX: 2,
      paddingY: 1
    }, page === currentPage && /*#__PURE__*/React.createElement(Icon, {
      icon: "check",
      color: "grey.600"
    }), /*#__PURE__*/React.createElement(Text, {
      px: page === currentPage ? 2 : 5,
      color: "black",
      fontWeight: "600",
      size: "regular"
    }, lowerLimit, " - ", upperLimit));
  })), /*#__PURE__*/React.createElement(MenuFooter, null, /*#__PURE__*/React.createElement(Columns, {
    space: "small",
    alignY: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "1",
    fontWeight: "medium",
    color: "grey.500"
  }, strings.showUpTo), /*#__PURE__*/React.createElement(Select, {
    size: "tiny",
    fullWidth: true,
    variant: "standard",
    options: rowLimitItems,
    onChange: onPageSizeChange,
    value: pageSize
  }))))), /*#__PURE__*/React.createElement(Columns, null, /*#__PURE__*/React.createElement(PaginationItem, {
    size: "medium",
    type: "previousIcon",
    disabled: currentPage === 1 || currentPage > totalPageSize,
    onClick: function onClick() {
      return onPageChange(currentPage - 1);
    }
  }), /*#__PURE__*/React.createElement(PaginationItem, {
    size: "medium",
    type: "nextIcon",
    disabled: currentPage >= totalPageSize,
    onClick: function onClick() {
      return onPageChange(currentPage + 1);
    }
  })));
};